import { Flow } from 'components/settings/components/sections/dixaMessenger/views/flow';
export const SettingsMessengerEditFlowView = Flow;
